import { render, staticRenderFns } from "./Wis.vue?vue&type=template&id=fcf87bd6"
import script from "./Wis.vue?vue&type=script&lang=js"
export * from "./Wis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports